import React from 'react';
import PropTypes from "prop-types";
import EventsTable from "../../../../../components/customBreachBits/events/EventsTable"

const EventsSection = (props, {children}) => {

    // const {customers, customerInView} = useSelector(({customer}) => customer);
    // console.log("Customers in BreachBoardContent: ", customers);
    // const customer = getInViewCustomerObject(customerInView, customers);

    const {customerId} = props;

    return (
        <div className={`bb-tab-section`}>
            <div className="row">
                <div className="col-12">
                    <EventsTable customerId={customerId}/>
                </div>
            </div>


        </div>
    )
};

EventsSection.propTypes = {
    customerId: PropTypes.string,
};

export default EventsSection;

